module.exports = __webpack_public_path__ + "media/12_ASANBUDAPEST-Atmosphere07.59fd5301.mp3";